const SERVICEREFRESHMENT_UPDATED = (state, ServiceRefreshment) => {
  state.ServiceRefreshment = ServiceRefreshment
}

export default {
  SERVICEREFRESHMENT_UPDATED
}
